import apiClient from '../apiClient';
import { GET_PAYABLE_SUPPLEMENT_ITEM_URL } from '../apiUrl';

const getPayableSupplemetItemApi = Id => {
  return apiClient.get(GET_PAYABLE_SUPPLEMENT_ITEM_URL(Id));
};

export default getPayableSupplemetItemApi;
